/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeHierarchyAssetDto
 */
export interface PartnerMaintenanceScopeHierarchyAssetDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeHierarchyAssetDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeHierarchyAssetDto
     */
    assetModelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeHierarchyAssetDto
     */
    manufacturerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeHierarchyAssetDto
     */
    cityCode?: string | null;
}

/**
 * Check if a given object implements the PartnerMaintenanceScopeHierarchyAssetDto interface.
 */
export function instanceOfPartnerMaintenanceScopeHierarchyAssetDto(value: object): value is PartnerMaintenanceScopeHierarchyAssetDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeHierarchyAssetDtoFromJSON(json: any): PartnerMaintenanceScopeHierarchyAssetDto {
    return PartnerMaintenanceScopeHierarchyAssetDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeHierarchyAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeHierarchyAssetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetModelId': json['assetModelId'] == null ? undefined : json['assetModelId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'cityCode': json['cityCode'] == null ? undefined : json['cityCode'],
    };
}

export function PartnerMaintenanceScopeHierarchyAssetDtoToJSON(json: any): PartnerMaintenanceScopeHierarchyAssetDto {
    return PartnerMaintenanceScopeHierarchyAssetDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeHierarchyAssetDtoToJSONTyped(value?: PartnerMaintenanceScopeHierarchyAssetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetModelId': value['assetModelId'],
        'manufacturerId': value['manufacturerId'],
        'cityCode': value['cityCode'],
    };
}

